﻿import { Coordinate } from 'ol/coordinate';

/** Unified type describing coordinates of all geometries (from Point to MultiPolygon). */
export type Coordinates = CoordinatesArray | Coordinate;

export interface CoordinatesArray extends Array<Coordinates> {
}

export const isCoordinate = (data: Coordinates | undefined) => {
    let coord: Coordinate | undefined = undefined;
    if (data) {
        for (let value of data) {
            if (typeof value === 'number') {
                coord = coord ?? [];
                coord.push(value);
            }
            else {
                coord = undefined;
                break;
            }
        }
    }

    return coord;
}

export const isFlatCoordinateArray = (data: Coordinates | undefined) => {
    let arr: Coordinate[] = [];
    if (data) {
        for (let value of data) {
            if (typeof value !== 'number') {
                const coord = isCoordinate(value);
                if (coord) {
                    arr.push(coord);
                    continue;
                }
            }
            return undefined;
        }
    }

    return arr;
}

export const isCoordinatesArray = (data: Coordinates | undefined) => {
    let list: CoordinatesArray | undefined = undefined;
    if (data) {
        for (let value of data) {
            if (typeof value !== 'number') {
                list = list ?? [];
                list.push(value);
            }
            else {
                list = undefined;
                break;
            }
        }
    }

    return list;
}

export const areSameCoordinateDataTypes = (...data: Coordinates[]): CoordinatesArray[] | Coordinate[] | undefined => {
    if (data.every(d => isCoordinate(d)))
        return data as Coordinate[];
    else if (data.every(d => isCoordinatesArray(d)))
        return data as CoordinatesArray[];
    return undefined;
}

export const flattenCoordinates = (data: Coordinates): Coordinate[] => {
    const point = isCoordinate(data);

    if (point)
        return [point];
    else {
        const flat = isFlatCoordinateArray(data);
        if (flat)
            return flat;
        else {
            const array = isCoordinatesArray(data);
            if (array) {
                let result: Coordinate[] = [];
                array.forEach(value => result = result.concat(flattenCoordinates(value)));
                return result;
            }
        }
    }

    return [];
}
